import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LabMDM } from "./models/lab";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { BBResponseContainer } from "../carrier/response-container";
import { CarrierState } from "./models/carrierState";
import { QcType } from "./models/qcType";
import { BusinessArea } from "./models/businessArea";
import { Machine } from "./models/machine";
import { Printer } from "./models/printer";
import { SeqConfig } from "./models/seqConfig";
import { Chemical } from "./models/chemical";
import { MachineType } from "./models/machineType";
import { Product } from "./models/product";
import { ChemicalCategory } from "./models/chemicalCatagory-enum";
import { LibType } from "./models/libType";
import { EchoConfig } from "./models/echoConfig";
import { SalesItemTypeConfig } from "./models/salesitemtype-config";
import { tap, timeout } from 'rxjs/operators';
import { StandardPrimer } from './models/standardPrimer';
import { Template } from './models/template';
import { SenderDTO } from './models/sender-dto';
import { KitsDTO } from './models/kits-dto';
import { ExternalSenderLoginDTO } from "./models/externalSenderLogin";
import { Manufacturers } from "./models/manufacturers";
import { RedoReason } from "./models/redoReason";
import { InboundFileProcessing } from "./models/inboundFileProcessing";
import { Tags } from "./models/tags";
import { TagSystem } from "./models/tag-system";


//Service used for crud opertaions on the master data
@Injectable()
export class MasterDataService {

    readonly LABMDMSERVICE = 'admin/mdm/lab';
    readonly BAMDMSERVICE = 'admin/mdm/ba';
    readonly QCTYPEMDMSERVICE = 'admin/mdm/qctype';
    readonly MACHINEMDMSERVICE = 'admin/mdm/machine';
    readonly PRINTERMDMSERVICE = 'admin/mdm/printer';
    readonly CARRIERSTATEMDMSERVICE = 'admin/mdm/carrier/state'
    readonly GETCOUNTRIESURL = 'admin/mdm/country'
    readonly SEQCONFIGMDMSERVICE = 'admin/mdm/seqConfig';
    readonly HELATHCHECK = 'health_check';
    readonly MACHINETYPEMDMSERVICE = 'admin/mdm/machinetype';
    readonly PRODUCTMDMSERVICE = 'admin/mdm/product';
    readonly PRODUCTMDMSERVICEBMS = 'admin/mdm/product/bmsProductName';
    readonly ACCESSLOG = 'admin/mdm/accesslog';
    readonly LIBTYPEMDMSERVICE = 'admin/mdm/libtype';
    readonly ECHOCONFIGURATION = 'admin/mdm/echoConfig';
    readonly SITCONFIGURATION = 'admin/mdm/salesItemType';
    readonly STANDARDPRIMER = 'admin/mdm/primer/standard';
    readonly TEMPLATEMDMSERVICE = 'admin/mdm/print/template';
    readonly SENDERMDMSERVICE = 'admin/mdm/sender';
    readonly KITMDMSERVICE = 'admin/mdm/kits';
    readonly PROBLEMCATEGORYMDMSERVICE = 'admin/mdm/problemcategory';
    readonly PROBLEMMDMSERVICE = 'admin/mdm/problem';
    readonly RESULTPROCESSMDMSERVICE = 'admin/mdm/result-process';
    readonly RESULTENGINECONFIGSERVICE = 'admin/mdm/resultConfig';
    readonly EXTERNALSENDERLOGINSERVICE = 'admin/mdm/eslogin';
    readonly MANUFACTURERSERVICE = 'admin/mdm/machine/manufacturer';
    readonly REDOREASON = 'admin/mdm/redoReason';
    readonly INBOUNDFILEPROCESSING = 'admin/mdm/inboundFileProcessing';
    readonly GENERIC_MDM_WORKFLOW = '/admin/mdm/generic';
    readonly ADMIN_MDM_GENERIC = 'admin/mdm/generic';
    readonly GENERIC_MDM = 'mdm/generic';
    readonly PRINTERMDMSERVICENONMDM = 'mdm/printer';
    constructor(private http: HttpClient) {
    }

    //Gets a list of labs
    getLabs(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of labs based on selected lab
    getLabsBasedOnSelectedLabForAppliedGenomics(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE + "/filter";
        let requestParam = new HttpParams().set('labId', lab._id);

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }


    //getLabsWithOptionalHistory
    getLabsWithOptionalHistory(active: boolean, includeHistory: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString())
            .set('includeHistory', includeHistory.toString());

        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new Lab
    addLab(lab: LabMDM) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, lab).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a lab
    updateLab(lab: LabMDM) {
        let url: string = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, lab).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of carrierStates
    getCarrierStates(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Creates a new carrierState
    addCarrierState(carrierState: CarrierState) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, carrierState).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a carrierState
    updateCarrierState(carrierState: CarrierState) {
        let url: string = environment.BB_MDMSERVICE_URL + this.CARRIERSTATEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, carrierState).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of qctypes
    getQCTypes(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new qcType
    addQcType(qcType: QcType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, qcType).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a qcType
    updateQcType(qcType: QcType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.QCTYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, qcType).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of machines
    getMachines(lab: LabMDM): Observable<BBResponseContainer> {

        if (lab.businessArea.name === "Applied Genomics") {

            let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE + "/covid";
            let requestParam = new HttpParams().set('labId', lab._id);

            const options = url ? { params: requestParam } : {};
            return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
                error.url = url;
            }));

        } else {
            let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
            return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
                error.url = url;
            }));
        }
    }
    //Creates a new machine
    addMachine(machine: Machine) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, machine).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a machine
    updateMachine(machine: Machine) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, machine).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of printers
    getPrinters(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        let emptyRequestParam = new HttpParams();
        let requestParam = (active) ? new HttpParams().set('active', active.toString()) : emptyRequestParam;
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of barcode page print templates
    getBarcodePagePrintTemplate(labId: string, active: boolean, printActive: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE + '/print';
        let emptyRequestParam = new HttpParams();
        let requestParam = (active) ? new HttpParams().set('active', active.toString()).set('printActive', printActive.toString()).set('labId', labId) : emptyRequestParam;
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    //Creates a new printer
    addPrinter(printer: Printer) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, printer).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a printer
    updatePrinter(printer: Printer) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, printer).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of businessArea
    getBusinessAreas(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Creates a new businessArea
    addBusinessArea(businessArea: BusinessArea) {
        let url: string = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, businessArea).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a businessArea
    updateBusinessArea(businessArea: BusinessArea) {
        let url: string = environment.BB_MDMSERVICE_URL + this.BAMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, businessArea).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of sequencer Configurations
    getSeqConfigs(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new sequencer Configuration
    addSeqConfig(seqConfig: SeqConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, seqConfig).pipe(timeout(environment.defaultTimeout), tap(event => { console.log("success"); }, error => {
            console.log("error");
            error.url = url;
        }));
    }

    //Updates a sequencer Configuration
    updateSeqConfig(seqConfig: SeqConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SEQCONFIGMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, seqConfig).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Gets a list of countries
    getCountries(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.GETCOUNTRIESURL;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getAllActiveChemicals(labId: string, entityName: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + labId + "/" + entityName + "/list?activeIndicator=true";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of chemicals
    getChemicals(labId: string, entityName: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + labId + "/" + entityName + "/list";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new chemical
    addChemical(chemical: Chemical, labId: string, entityName: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + labId + "/" + entityName;
        return this.http.post<BBResponseContainer>(url, chemical).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    //updates a chemical
    updateChemical(chemical: Chemical, labId: string, id: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + labId + "/chemical/" + id;;
        return this.http.put<BBResponseContainer>(url, chemical).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Retrives all service health information
    getHealthStatus(): Observable<any> {
        let url: string = environment.BB_APIGATEWAY_SERVICE_URL + this.HELATHCHECK;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //Gets a list of machinetypes
    getMachineTypes(active: boolean, lab: LabMDM): Observable<BBResponseContainer> {
        if (lab && lab.businessArea.name === "Applied Genomics") {
            let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE + "/covid";
            let requestParam = new HttpParams().set('active', active.toString()).set("labId", lab._id);
            const options = url ? { params: requestParam } : {};
            return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
                error.url = url;
            }));

        } else {

            let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
            let requestParam = new HttpParams().set('active', active.toString());
            const options = url ? { params: requestParam } : {};
            return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
                error.url = url;
            }));
        }
    }

    //Creates a new machineType
    addMachineType(machineType: MachineType) {
        console.log("adding machineType Object : " + machineType);
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, machineType).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a machineType
    updateMachineType(machineType: MachineType) {
        let url: string = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, machineType).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of product
    getProducts(active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Creates a new product
    addProduct(product: Product) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, product).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a product
    updateProduct(product: Product) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, product).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProductsByLab(labId: string, active: boolean) {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE + '/labId/' + labId;
        let requestParam = new HttpParams().set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //to get sales item type
    getSalesItemType(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.SITCONFIGURATION;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    //to get sales item type
    getSalesItemTypeFilteredByLab(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/salesItemType/list?pageNumber=0&limit=100";
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //to get sales item type
    getBmsProductName(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICEBMS;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //to get access log
    getAccessLog(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.ACCESSLOG;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    addSITConfiguration(labId: string, salesItemTypeConfig: SalesItemTypeConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/" + "salesItemType";
        return this.http.post<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //updates a echo configuration
    updateEchoConfig(echoConfig: EchoConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.ECHOCONFIGURATION;
        return this.http.put<BBResponseContainer>(url, echoConfig).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    updateSITConfiguration(labId: string, id: string, salesItemTypeConfig: SalesItemTypeConfig) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/salesItemType/" + id;
        return this.http.put<BBResponseContainer>(url, salesItemTypeConfig).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getStandardPrimer(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    updateStandardPrimer(standardPrimer: StandardPrimer): any {
        let url: string = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.put<BBResponseContainer>(url, standardPrimer).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }
    addStandardPrimer(standardPrimer: StandardPrimer): any {
        let url: string = environment.BB_MDMSERVICE_URL + this.STANDARDPRIMER;
        return this.http.post<BBResponseContainer>(url, standardPrimer).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Insert a template
    addTemplate(template: Template) {
        let url: string = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, template).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
        }));
    }

    //Update a template
    updateTemplate(template: Template) {
        let url: string = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, template).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get all the templates from DB
    getTemplates(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get all the templates from DB
    getSenders(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Get the Active Templates from Master DB For passed lab
    getActiveTemplatesForLab(lab: LabMDM, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.TEMPLATEMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id).
            set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    addSender(sender: SenderDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        return this.http.post<BBResponseContainer>(url, sender).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
        }));
    }

    updateSender(sender: SenderDTO) {
        let url: string = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE;
        return this.http.put<BBResponseContainer>(url, sender).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getMapOfSenders(labId: string, active: boolean): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.SENDERMDMSERVICE + "/mapOfSenders";
        let requestParam = new HttpParams().set('labId', labId).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    addKit(kit: KitsDTO, machineImage: File): Observable<BBResponseContainer> {
        let url: string = environment.BB_MDMSERVICE_URL + "admin/mdm/kits-image?insert=" + true;
        let formData: FormData = new FormData();
        formData.append('uploadFile', machineImage);
        formData.append('kit', new Blob([JSON.stringify(kit)], { type: "application/json" }));
        return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
    }

    updateKit(kit: KitsDTO, machineImage: File): Observable<BBResponseContainer> {
        let url: string = environment.BB_MDMSERVICE_URL + "admin/mdm/kits-image?insert=" + false;
        let formData: FormData = new FormData();
        formData.append('uploadFile', machineImage);
        formData.append('kit', new Blob([JSON.stringify(kit)], { type: "application/json" }));
        return this.http.post<BBResponseContainer>(url, formData).pipe(timeout(environment.defaultTimeout));
    }

    //Get all the templates from DB
    getKits(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getMachineSubTypes(machineType: string, labId: string) {
        let url = environment.BB_MDMSERVICE_URL + this.MACHINEMDMSERVICE + '/subTypes/' + machineType + '/' + labId + '/' + true;
        return this.http.get<any>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemCategory(): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getProblemCategoriesList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE + '/all';
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getActiveProblemCategoriesList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMCATEGORYMDMSERVICE + '/' + lab._id + '/' + true;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getProblemList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.PROBLEMMDMSERVICE + '/all';
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getResultProcessList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.RESULTPROCESSMDMSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    findLabById(selectedLabId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.LABMDMSERVICE + "/" + selectedLabId;
        return this.http.get<BBResponseContainer>(url).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getSenderSpecificKits(selectedLabId: string, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE + '/listBasedOnPCRAndExtraction';
        let requestParam = new HttpParams().set('labId', selectedLabId).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getResultConfigList(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.RESULTENGINECONFIGSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getResultConfigNames(lab: string, kitLot: string) {
        let url = environment.BB_MDMSERVICE_URL + "resultConfig/getResultConfigNames/" + lab;
        let requestParam = new HttpParams().set('kit', kitLot);
        const options = url ? { params: requestParam } : {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    getResultForKitCyclerResultCombo(selectedLabId: string, kitCyclerResultCombo: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/resultConfigExistence';
        let requestParam = new HttpParams().set('labId', selectedLabId).set('kitNameCyclerResultName', kitCyclerResultCombo);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    getKitsFromMDM(labID: string, swabRestriction: string, extractorKits: string, pcrKits: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/kits/kitTypes' + '/' + labID + '/' + swabRestriction;
        let requestParam = new HttpParams().set('extractorKits', extractorKits).set('pcrKits', pcrKits);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    //Get all the external sender logins configured for the lab
    getExternalSenderLogins(lab: LabMDM): Observable<BBResponseContainer> {

        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }

    addExternalSenderLogin(externalSenderLogin: ExternalSenderLoginDTO): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        return this.http.post<BBResponseContainer>(url, externalSenderLogin).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
        }));
    }

    updateExternalSenderLogin(externalSenderLogin: ExternalSenderLoginDTO): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.EXTERNALSENDERLOGINSERVICE;
        return this.http.put<BBResponseContainer>(url, externalSenderLogin).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
        }));
    }

    getManufacturerList(labId: string): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
        let requestParam = new HttpParams().set('labId', labId);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    updateManufacturer(selectedMasterList: Manufacturers) {
        let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
        return this.http.put<BBResponseContainer>(url, selectedMasterList).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    saveManufacturer(selectedMasterList: Manufacturers) {
        let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE;
        return this.http.post<BBResponseContainer>(url, selectedMasterList).pipe(tap(event => { }, error => {
            error.url = url;
        }));
    }
    getActiveMachineTypes(active: boolean, labId: string) {
        let url = environment.BB_MDMSERVICE_URL + this.MACHINETYPEMDMSERVICE;
        let requestParam = new HttpParams().set('active', active.toString()).set("labId", labId);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getPattersFromManufacturer(manufacturerName: string, labId: string) {
        let url = environment.BB_MDMSERVICE_URL + this.MANUFACTURERSERVICE + '/' + manufacturerName;
        let requestParam = new HttpParams().set("labId", labId);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getManufacturesFromMachineTypeAndLabId(machineType: string, labId: string) {
        let url = `${environment.BB_MDMSERVICE_URL}${this.MANUFACTURERSERVICE}/${labId}/${machineType}`;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }
    getKitImage(kitName, imageName: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE + "/getKitImage/";
        let requestParam = new HttpParams().set('kitName', kitName).set('imageName', imageName);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    getRedoReasons(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.REDOREASON;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    saveRedoReason(redoReason: RedoReason) {
        let url = environment.BB_MDMSERVICE_URL + this.REDOREASON;
        return this.http.post<BBResponseContainer>(url, redoReason).pipe(timeout(environment.defaultTimeout));
    }
    updateRedoReason(redoReason: RedoReason) {
        let url = environment.BB_MDMSERVICE_URL + this.REDOREASON;
        return this.http.put<BBResponseContainer>(url, redoReason).pipe(timeout(environment.defaultTimeout));
    }
    getInboundFileProcessing(lab: LabMDM): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEPROCESSING;
        let requestParam = new HttpParams().set('labId', lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    saveInboundFileProcessing(inboundFileProcessing: InboundFileProcessing) {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEPROCESSING;
        return this.http.post<BBResponseContainer>(url, inboundFileProcessing).pipe(timeout(environment.defaultTimeout));
    }
    updateInboundFileProcessing(inboundFileProcessing: InboundFileProcessing) {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEPROCESSING;
        return this.http.put<BBResponseContainer>(url, inboundFileProcessing).pipe(timeout(environment.defaultTimeout));
    }
    getActiveInboundFileProcessing(activeFlag: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + this.INBOUNDFILEPROCESSING + '/active';
        let requestParam = new HttpParams().set('active', activeFlag.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }
    getKitByName(lab, kitName, kitType: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.KITMDMSERVICE + "/kitName";
        let requestParam = new HttpParams().set('lab', lab).set('kitName', kitName).set('kitType', kitType);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    createWorkFlow(json: string, labId: string, entityName: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/" + entityName;
        return this.http.post<BBResponseContainer>(url, json).pipe(timeout(environment.defaultTimeout));
    }

    getWorkFlow(labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/workflow/list?pageNumber=0&limit=100";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    updateWorkFlow(json: string, labId: string, id: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/workflow/" + id;
        return this.http.put(url, json).pipe(timeout(environment.defaultTimeout));
    }

    updateNGSWorkFlow(json: string, labId: string, id: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/workflowngs/" + id;
        return this.http.put(url, json).pipe(timeout(environment.defaultTimeout));
    }

    saveControlConfiguration(lab: LabMDM, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab._id + "/" + "controls";
        return this.http.post<BBResponseContainer>(url, controls).pipe(timeout(environment.defaultTimeout));
    }
    updateControlConfiguration(lab: LabMDM, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab._id + "/" + "controls" + "/" + controls._id;
        return this.http.put<BBResponseContainer>(url, controls).pipe(timeout(environment.defaultTimeout));
    }
    getControlConfiguration(lab: LabMDM, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM + "/" + lab._id + "/" + controls + "/list";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getControls(lab: string, controls) {
        let url = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM + "/" + lab + "/" + controls + "/list";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getWorkFlowByWorkflowName(labId: string, workflowName: string) {
        let query = "{\"query\":{\"workFlowName\":\"Single Sample\"}}";
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/workflow/query";
        return this.http.post<BBResponseContainer>(url, query).pipe(timeout(environment.defaultTimeout));
    }

    getEntityFromGenericMDMQuery(labId: string, queryObj: any, entityName: string ) {
        const url: string = `${environment.BB_MDMSERVICE_URL}${this.GENERIC_MDM_WORKFLOW}/${labId}/${entityName}/query`;
        return this.http.post<any>(url, queryObj).pipe(timeout(environment.defaultTimeout),tap(error => {
            error.url = url;
        }));;
    }

    getAllActiveWorkFlow(labId: string) {
        let url: string = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM_WORKFLOW + "/" + labId + "/workflow/list?activeIndicator=true";
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    getConfigList(labID: string, configName: string, pageNumber: number, limit: number, active?: boolean) {
        let url;
        if (active) {
            url = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM + "/" + labID + "/" + configName + "/list?pageNumber=" + pageNumber + "&limit=" + limit + "&activeIndicator=" + active;
        } else {
            url = environment.BB_MDMSERVICE_URL + this.GENERIC_MDM + "/" + labID + "/" + configName + "/list?pageNumber=" + pageNumber + "&limit=" + limit;
        }
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout));
    }

    saveConfig(lab: LabMDM, configData: any, configName: string) {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab._id + "/" + configName;
        return this.http.post<BBResponseContainer>(url, configData).pipe(timeout(environment.defaultTimeout));
    }

    updateConfig(lab: LabMDM, configData: any, configName: string) {
        let url = environment.BB_MDMSERVICE_URL + this.ADMIN_MDM_GENERIC + "/" + lab._id + "/" + configName + "/" + configData._id;
        return this.http.put<BBResponseContainer>(url, configData).pipe(timeout(environment.defaultTimeout));
    }

    //Gets a list of printers filtered by lab id and entity type
    getFilteredPrintersForLabAndEntity(active: boolean, labid: string, labelTemplate: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + this.PRINTERMDMSERVICENONMDM + '/filter';
        let requestParam = new HttpParams().set('active', active.toString()).set('labId', labid).set('entityFilter', labelTemplate);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap(error => {
            error.url = url;
        }));
    }

    getMapOfTagsFromMDM(selectedLabId: string, tagSystem: string): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + 'mdm/tags/' + selectedLabId + '/' +tagSystem;
        return this.http.get<BBResponseContainer>(url).pipe(tap(error => {
            error.url = url;
        }));
    }

    getTags(lab: LabMDM): Observable<any> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tags';
        let requestParam = new HttpParams().set("labId",lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

    addTag(tag: Tags): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tags';
        return this.http.post<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout), tap(error => {
            error.url = url;
        }));
    }

    updateTag(tag: Tags): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tags';
        return this.http.put<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout), tap(error => {
            error.url = url;
        }));
    }
    saveTagPlates(tag: Tags): Observable<any> {
        let url = environment.BB_APG_SAMPLE_PROCESSING_URL + 'covid19Batch/tag/update';
        return this.http.put<BBResponseContainer>(url, tag).pipe(timeout(environment.defaultTimeout), tap(error => {
            error.url = url;
        }));
    }

    getTagsystem(lab: LabMDM): Observable<any> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem'
        let requestParam = new HttpParams().set("labId",lab._id);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

    getTagActiveSystem(lab: LabMDM, active: boolean): Observable<any> {

        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem'
        let requestParam = new HttpParams().set("labId",lab._id).set("active", active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

    addTagSystem(tagSystem: TagSystem): Observable<any>{
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem';
        return this.http.post<BBResponseContainer>(url, tagSystem).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }
    
    updateTagSystem(tagSystem: TagSystem): Observable<any>{
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem';
        return this.http.put<BBResponseContainer>(url, tagSystem).pipe(timeout(environment.defaultTimeout),tap( error => {
            error.url = url;
        }));
    }

    checkExistance(labId: string,tagSystemName:string) : Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/tagSystem/exist';
        let requestParam = new HttpParams().set('labId',labId).set("tagSystemName",tagSystemName)
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(tap( error => {
            error.url = url;
        }));
    }

    getMapOfTagsFromMDMForPlannedTagPlates(selectedLabId: string, tagSystemName: string, flag: boolean): Observable<any> {
        let url = environment.BB_MDMSERVICE_URL + 'mdm/tags/' + selectedLabId + '/' +tagSystemName;
        let requestParam = new HttpParams().set('flag', flag.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
            error.url = url;
        }));
    }

    getMapOfTags(selectedLabId: string, tagSystem: string): Observable<any> {
        const url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/tags?lab=" + selectedLabId;
        let requestParam = new HttpParams().set('tagSystemName', tagSystem? tagSystem : "");
        const options = url ? { params: requestParam } : {};
        return this.http.get<any>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    getSNPThresHoldValueFromMDM(productName: string, lab: string): Observable<any> {
        let url: string = environment.BB_MDMSERVICE_URL + this.PRODUCTMDMSERVICE + "/snpProfile";
        let requestParam = new HttpParams().set("productName", productName).set("labId", lab);
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout), tap(error => {
            error.url = url;
        }));
    }

    getReceptionIssueRedos(labid:string):Observable<BBResponseContainer>{
        let url = `${environment.BB_MDMSERVICE_URL}${this.GENERIC_MDM}/${labid}/redoReasons/query`
        let query = "{\"query\":{\"receptionIssue\":true},\"project\":{\"reasonName\":1}}"
        return this.http.post<BBResponseContainer>(url,query)
    }
}
